'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import Accordion from '../components/Accordion'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--single'
        this.$catAccordion = this.view.querySelector('.jsAccordion--cat')
        this.$faq = this.view.querySelector('.jsAccordion--main')
        // Fns
        if(this.$faq != null) {
            this.faqAccordions()
        }
        if(this.$catAccordion != null && Env.mobileCSS == true) {
          this.catAccordions()
      }
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    catAccordions()
    {
      setTimeout(() => {
        const instance = new Accordion(this.$catAccordion)
        instance.setup()
      }, 500);
    }

    faqAccordions()
    {
      setTimeout(() => {
        const $items = this.view.querySelectorAll('.jsAccordion--view')

        for(let $item of $items) {
          const instance = new Accordion($item)
          instance.setup()
        }
      }, 500);
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 200);
    }

    intro()
    {
      Env.framework.UI.fxIntro(this.view)
    }
}

page = Barba.BaseView.extend({
    namespace: 'single',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;
